import React, {Component} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import scrollToElement from 'scroll-to-element';
import Helmet from 'react-helmet'
import Favicon from 'react-favicon'
import './normalize.css'
import styles from './Rist.css'
import Menu from './modules/Menu'
import Footer from './modules/Footer'

const plugScript = (id, src) => {
  if (!document.getElementById(id)) {
    const firstjs = document.getElementsByTagName('script')[0]
    const loadedScript = document.createElement('script');
    loadedScript.id = id
    loadedScript.src = src
    firstjs.parentNode.insertBefore(loadedScript, firstjs);
  }
}



class Rist extends Component {
  componentDidMount () {
    this.jumpToHash();

    plugScript('youtube-js', 'https://www.youtube.com/iframe_api')

    window.hj = window.hj || function () {
      (window.hj.q = window.hj.q || []).push(arguments)
    }
    window._hjSettings = {
      hjid:394923,
      hjsv:5
    }
    plugScript('hotjar', '//static.hotjar.com/c/hotjar-' + window._hjSettings.hjid + '.js?sv=' + window._hjSettings.hjsv, true)
  }

  componentDidUpdate() {
    this.jumpToHash();
  }

  jumpToHash = () => {
    const hashParts = window.decodeURIComponent(location.hash).split('#')
    if (hashParts.length < 2) {
      scrollTo(0,0)
    }
    else {
      scrollToElement('#'+hashParts[1], { offset: -80 });
    }
  }

  render () {
    return (
      <div className={styles.cont}>
        <Favicon url={require('./favicon.png')}/>
        <Helmet titleTemplate={this.props.primaryTitle+" | %s"} title={this.props.secondaryTitle}/>
        <Menu menu={this.props.menu} logo={this.props.logo}/>
        <div className={styles.main}>
          {this.props.children}
          <Footer links={this.props.footer.links} copyright={this.props.footer.copyright}/>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    logo: state.rist.content.logo,
    menu: state.rist.content.menu,
    primaryTitle: state.rist.content.feature.primaryTitle,
    secondaryTitle: state.rist.content.feature.primaryTitle,
    footer: state.rist.content.footer,
  })
)(Rist))



// WEBPACK FOOTER //
// ./src/Rist/index.js